import { useMutation } from '@connectrpc/connect-query'
import { checkEmail } from '@jotta/grpc-connect-openapi/esm/openapi/signup/v1/signup.v1-SignupService_connectquery'
import { createConnectQuery } from '../createConnectQuery'

export const checkEmailQuery = createConnectQuery(checkEmail)

export function useCheckEmail() {
  return useMutation(checkEmail)
}
